<template>
  <ion-page>
    <master-layout pageTitle="اطلاعات مأموریت">
      <Loading v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
        <div v-if="mission">
          <IonCardContent>
            <div class="mb-1">ش مأموریت : {{mission.mission_number}}</div>
            <div class="mb-1">عنوان : {{ mission.title }}</div>
            <div class="mb-1"><i class="far fa-calendar-alt"></i>&nbsp;شروع : {{mission.begin_date}}</div>
            <div><i class="far fa-calendar-alt"></i>&nbsp;پایان : {{mission.end_date}}</div>
            <router-link class="btn btn-block btn-info mt-1 mb-1" :to="'/deliverMissionAllItems/'+mission._id">مشاهده کلی محصولات مأموریت&nbsp;<i class="far fa-boxes"></i></router-link>
            <AjaxForm v-if="mission.status" :route="'deliverMission/changeStatusToFinish/'+mission._id">
              <button class="btn btn-success btn-block mt-1" type="submit">اتمام مأموریت</button>
            </AjaxForm>
            <div v-else class="center alert alert-success">تمام شده</div>
            <DataTable card="1" :datas="table_data" :headers="table_headers"></DataTable>
          </IonCardContent>
        </div>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage,IonCardContent} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "../../components/Loading";
import DataTable from "../../components/DataTable";
import AjaxForm from "../../components/AjaxForm";



export default {
  name: "missionItemInfo",
  components: {AjaxForm, IonPage,Loading,DataTable,IonCardContent},
  data()
  {
    return {
      id: null,
      pageLoaded : false,
      mission: null,
      mission_items: null,
      error : false,
      table_data : [],
      table_headers : ['شماره حواله','مشتری','شماره تماس','وضعیت','امکانات'],
    }
  },
  async mounted()
  {
    await this.init();
  },
  methods: {
    ...mapActions('mission',{
      getMissionOrders: 'getMissionOrders',
    }),
    async init()
    {
      this.pageLoaded = false;
      this.customer = null;
      this.mission = null;
      this.error = null;
      this.id = this.$route.params.id;
      const result = await this.getMissionOrders(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.mission = result.mission;
          const mission_items = result.mission_items;
          this.mission_items = mission_items;
          const data_table = [];
          for (let i = 0; i < mission_items.length; i++)
          {
            const m = mission_items[i];
            const location = m.location.coordinates;
            const user = m.order.user;
            let status = m.result;
            if (!status)
              status = 'ارسال شده';
            else if (status === 1)
              status = 'تحویل شده';
            else if (status === 2)
              status = 'برگشت خورده';
            const options = '<router-link to="/DeliverMissions/itemId/'+m._id+'" class="btn btn-info"><i class="far fa-eye"></i></router-link>&nbsp;' +
                '<a href="geo:'+location[1]+','+location[0]+'" class="btn btn-warning"><i class="far fa-directions"></i></a>&nbsp;' +
                '<a href="tel:'+user.phone+'" class="btn btn-success"><i class="far fa-phone"></i></a>';
            data_table.push([m.order.order_number,user.fullname,'0'+user.phone,status,options]);
          }
          this.table_data = data_table;
          this.pageLoaded = true;
        }
        else
        {
          this.pageLoaded = true;
          this.error = result.error;
        }
      }
      else
      {
        this.pageLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    }
  },
  watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('delivermissions/info/') >= 0 && oldUrl.toLowerCase().indexOf('delivermissions/info/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>
.space_between
{
  display: flex;
  justify-content: space-between;
}
.mb-1
{
  margin-bottom: 5px;
}
.mr-1
{
  margin-right: 5px;
}
.customer_btn{
  padding: .3rem .7rem .3rem;
  margin-left: 5px;
}
</style>